import { adImageUrl, api, publicAdImageUrl } from './api';
import { ShareExtras } from './logoBand';

/** The day's adverts and both flash-news bars, for the picture that is about to be saved or shared. Missing pieces are simply left out. */
export async function loadShareExtras(date: string, signedIn: boolean, token?: string): Promise<ShareExtras> {
  // a person on a shared link reads the adverts of that link's day through the link itself; the flash-news headlines are public
  const [ads, flash] = await Promise.all([signedIn ? api.ads(date).catch(() => []) : token ? api.publicAds(token).catch(() => []) : Promise.resolve([]), (signedIn ? api.flash() : api.publicFlash()).catch(() => [])]);
  const ad = (n: number) => {
    const a = ads.find((x) => x.slot === n);
    return a ? (signedIn || !token ? adImageUrl(a) : publicAdImageUrl(token, a)) : undefined;
  };
  const texts = (slot: number) => flash.filter((f) => (f.slot ?? 1) === slot).map((f) => f.text);
  return { ads: { left: ad(1), right: ad(2) }, flashTop: texts(1), flashBottom: texts(2) };
}
